import api from '@/api'
import { mergeDeep } from '@/helpers/helpers'

export default {
  actions: {
    async fetchAuthUser (ctx) {
      const response = await api.Auth.me()
      if (response.data && response.message !== 'Unauthenticated.') {
        ctx.commit('updateUser', response.data)
      }
    },

    updateUser (ctx, user) {
      ctx.commit('updateUser', user)
    },

    updateCompany (ctx, company) {
      ctx.commit('updateCompany', company)
    }
  },
  mutations: {
    updateUser (state, user) {
      state.user = user
    },
    updateCompany (state, company) {
      state.user.companies[0] = mergeDeep(state.user.companies[0], company)
    }
  },
  state: {
    user: {}
  },
  getters: {
    authUser (state) {
      return state.user
    },
    isAuth (state) {
      return Object.keys(state.user).length > 0
    },
    isEmailVerified (state) {
      return state.user.email_verified
    },
    isAuthUserCompany (state) {
      return state.user.companies.length > 0 && Object.keys(state.user.companies[0]).length > 0
    },
    authUserCompany (state) {
      return state.user.companies[0]
    }
  }
}
